import { View } from "binder"
import { SettingViewModel } from "./setting-viewModel";

export class SettingView extends View<SettingViewModel>{
    GetViewUniqueId(): string {
        return "V-64A36D1C-8E24-4B2D-8A74-9E2B1C7081BD"
    }
    loadHtml(): string {
        let element = require('./setting.html').default;
        let style = require('./setting.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set showProductIndexOnPrint(v: boolean) { this._showProductIndexOnPrint = v; } public get showProductIndexOnPrint(): boolean { return this._showProductIndexOnPrint;} private _showProductIndexOnPrint: boolean;

    toggleShowProductIndexOnPrint(){
        this.dataContext.toggleShowProductIndexOnPrint();
    }
}
